import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-study-progress-bar',
  templateUrl: './study-progress-bar.component.html',
  styleUrls: ['./study-progress-bar.component.scss'],
})
export class StudyProgressBarComponent  implements OnInit {

  @Input() studyProgress: number = 0;
  @Input() isTypeCamp: boolean = false;
  @Input() duration: string = "";
  @Input() currentLesson: number = 0;
  @Input() totalLessons: number = 0;

  constructor() { }

  ngOnInit() {
    this.studyProgress = this.currentLesson/this.totalLessons * 100;
  }

}
